// import Tab from 'bootstrap/js/src/tab';
import TabsHelper from './helpers/tabs-helper';

class Header {
  constructor() {
    this.header = document.querySelector('.header');
    this.mainMenuTabLinks = this.header.querySelectorAll('.menu-primary .nav-link');
    this.locationsMenuLink = this.header.querySelector('.nav-type-locations > a');
    this.featuredTabLink = this.header.querySelector('.nav-type-featured [data-bs-toggle=tab]');
    this.firstLocationTab = this.getFirstLocationTab();
    this.isScrolling = false;
    this.backButtons = this.header.querySelectorAll('.close-tab');
    this.searchCollapse = this.header.querySelector('.meta-search-collapse');

    this.setListeners();
  }

  setListeners() {
    document.addEventListener('scroll', () => this.setHeaderStickyClass());
    document.addEventListener('click', (e) => this.hideSubmenuOnClick(e));
    document.addEventListener('keydown', (e) => this.hideSubmenuOnEsc(e));
    this.locationsMenuLink.addEventListener('shown.bs.tab', () => this.triggerFirstLocationTab());
    this.searchCollapse.addEventListener('shown.bs.collapse', () => this.focusSearch());

    this.backButtons.forEach((backButton) => {
      backButton.addEventListener('click', (e) => this.hideCurrentSubmenu(e));
    });

    this.mainMenuTabLinks.forEach((tabLink) => {
      tabLink.addEventListener('show.bs.tab', (e) => {
        if (!e.target.classList.contains('active')) {
          e.target.setAttribute('data-show', 'true');
        }
      });
      tabLink.addEventListener('shown.bs.tab', () => this.toggleHeaderClass());
      tabLink.addEventListener('hidden.bs.tab', () => this.toggleHeaderClass());
    });
  }

  setHeaderStickyClass() {
    let lastScrollY = 0;
    const scrollIntentThreshold = 20; // Change this value to adjust sensitivity

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (!this.isScrolling) {
        window.requestAnimationFrame(() => {
          // Add or remove sticky class
          this.header.classList.toggle('is-sticky', currentScrollY > 0);

          // Check scroll direction
          const scrollDifference = Math.abs(currentScrollY - lastScrollY);
          if (scrollDifference > scrollIntentThreshold) {
            if (currentScrollY > lastScrollY) {
              this.header.setAttribute('data-scroll', 'down');
            } else if (currentScrollY < lastScrollY) {
              this.header.setAttribute('data-scroll', 'up');
            }

            lastScrollY = currentScrollY;
          }

          this.isScrolling = false;
        });

        this.isScrolling = true;

        if (currentScrollY <= 0) {
          this.header.setAttribute('data-scroll', 'up');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
  }

  hideSubmenuOnClick(event) {
    // Select the active tab and tab pane
    const activeTab = this.header.querySelector('.nav-link.active');
    const activeTabPane = this.header.querySelector('.tab-pane.active');

    const aboutToShow = event.target.getAttribute('data-show') === 'true';

    if (aboutToShow) {
      event.target.setAttribute('data-show', false);
    }

    // Check if there's an active tab and pane
    if (activeTab && activeTabPane) {
      // Define the elements where clicks should not hide the active tab (menu and tab content)
      const navTabs = this.header.querySelector('[role=tablist]');
      const tabContent = this.header.querySelector('.tab-content');

      // If the click is outside the nav-tabs or tab-content, hide the active pane
      if (!navTabs.contains(event.target) && !tabContent.contains(event.target)) {
        this.deactivateTab(activeTab, activeTabPane);
      }

      // Or if clicking on the toggling menu item
      if (event.target === activeTab && !aboutToShow) {
        const tabPaneTarget = activeTab.getAttribute('href');
        const tabPane = document.querySelector(tabPaneTarget);

        if (tabPane.classList.contains('active') && tabPane.classList.contains('show')) {
          event.preventDefault();
          this.deactivateTab(activeTab, activeTabPane);
        }
      }
    }
  }

  hideSubmenuOnEsc(event) {
    // Check if the Esc key is pressed
    if (event.key !== 'Escape') {
      return;
    }

    this.hideActiveSubMenu();
  }
  
  hideActiveSubMenu() {
    // Select the active tab and tab pane
    const activeTab = this.header.querySelector('.nav-link.active');
    const activeTabPane = this.header.querySelector('.tab-pane.active');
  
    // If there's an active tab and pane, hide them
    this.deactivateTab(activeTab, activeTabPane);
  }

  hideCurrentSubmenu(event) {
    const currentTabPane = event.currentTarget.closest('.tab-pane');
    const activeTab = this.header.querySelector(`.nav-link.active[data-bs-toggle=tab][href="#${currentTabPane.id}"]`);

    this.deactivateTab(activeTab, currentTabPane);
  }

  deactivateTab(tab, pane) {
    const tabDeactivated = TabsHelper.deactivateTab(tab, pane);

    if (tabDeactivated) {
      this.toggleHeaderClass();
    }
  }

  triggerFirstLocationTab() {
    if (window.matchMedia('(min-width: 1025px)').matches) {
      this.firstLocationTab.show();
    }
  }

  getFirstLocationTab() {
    const locationsTabID = this.locationsMenuLink.getAttribute('href');
    const locationsTabEl = document.querySelector(locationsTabID);
    const firstLocation = locationsTabEl.querySelector('.nav-locations-countries > .nav-item:first-child > a');
    return window.BootstrapTab.getInstance(firstLocation) || new window.BootstrapTab(firstLocation);
  }

  toggleHeaderClass() {
    /* eslint-disable arrow-body-style */
    let tabMenuActive = Array.from(this.mainMenuTabLinks).find((tabLink) => {
      return tabLink.classList.contains('active');
    });

    tabMenuActive = tabMenuActive || false;
    this.header.classList.toggle('submenu-open', tabMenuActive);
  }

  focusSearch() {
    const search = this.header.querySelector('.search-input-wrap input');
    search.focus();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  /* eslint-disable no-new */
  new Header();
});
